<template>
  <router-view />
</template>

<script>
export default {
  name: "cashier",
};
</script>

